import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { variantOptionsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantOptions";
import { css } from "styled-components";

priceStyles.productPrice = {
    price: {
        priceText: { size: 32, fontFamily: "LibreBaskervilleBold" },
        unitOfMeasureText: { size: 26, fontFamily: "LibreBaskervilleBold" },
    },
};
